import React from 'react';

export const CountBand: React.FC<{ label?: string; value: number | string; detail: string }> = ({ label = 'Live total', value, detail }) => (
  <section className="count" aria-label={`${detail}: ${value}`}><span>{label}</span><strong>{value}</strong><p>{detail}</p></section>
);
